import { publicApi } from '@shared/config/axios.config';

interface AlumniContactPayload {
  username: string;
  code: string;
}

export const alumniContactApi = (payload: AlumniContactPayload) => {
  return publicApi.post('/contact/alumni_discord', payload);
};
